module.exports = __webpack_public_path__ + "static/img/093_TO8_1762_og.6fab4ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/093_TO8_1762_og.jpg
// module id = DyyU
// module chunks = 0